import React, {Component} from 'react';
import {connect} from 'react-redux';
import Typekit from 'react-typekit';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import {Link} from 'react-router-dom';

class WalkingTourFrameTest extends Component {
	componentWillUpdate() {
		window.scrollTo(0, 0);
	}

	isSingle() {
		return 1 === this.props.posts.length;
	}

	getClasses() {
		return this.isSingle() ? 'content-wrapper fom-pages walking-tour': 'content-wrapper fom-pages walking-tour';
	}

	render() {
		return (
			<div>
				<Typekit kitId="eab1tpm" />
				<main className={this.getClasses()}>
					<div className="title-block">
						<div className="nav-back">
	                		<Link to={'/home/'}>{'<'}</Link>
						</div>
						<h1>Village Walking Tours</h1>
					</div>
					<iframe src="https://marshallton.chestercountykiosk.com/walking-tour-test-november" width="1080" className="walking-tour-iframe" />
				</main>
			</div>
		);
	}
}


function mapStateToProps({posts}) {
	return {posts};
}

export default connect(mapStateToProps)(WalkingTourFrameTest)


// WEBPACK FOOTER //
// ./src/components/walkingtour-frame-test.js